module.exports = __webpack_public_path__ + "static/media/400002_01.9daac879.png";